var _circle, _path, _path2, _rect, _path3, _rect2, _path4, _rect3, _path5, _rect4, _path6, _rect5, _path7, _rect6, _path8, _rect7, _path9, _rect8, _path10, _rect9, _path11, _rect10, _path12, _rect11, _path13, _rect12, _rect13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99,
    fill: "#1D4C4E",
    stroke: "#F4F3F3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.02 153.852L100.834 141.235L115.088 130.584L121.765 153.287C121.895 153.728 121.41 154.096 121.02 153.852ZM113.86 130.253L100.449 140.274V130.253H113.86ZM113.722 129.253H100.449V120.346L113.722 129.253ZM114.494 128.567L100.847 119.409L109.995 113.27L114.494 128.567ZM99.4494 130.253V140.274L86.0387 130.253H99.4494ZM84.811 130.584L99.0648 141.235L78.8785 153.852C78.4885 154.096 78.004 153.728 78.1338 153.287L84.811 130.584ZM99.4494 129.253H86.1767L99.4494 120.346V129.253ZM109.464 112.422L100.449 118.471V104.523L109.464 112.422ZM109.317 110.964L100.708 103.42L105.789 98.9676L109.317 110.964ZM105.478 97.9105L100.449 102.317V80.8138L105.478 97.9105ZM85.4042 128.567L89.9035 113.27L99.0521 119.409L85.4042 128.567ZM90.435 112.422L99.4494 104.523V118.471L90.435 112.422ZM99.1907 103.42L90.5817 110.964L94.11 98.9676L99.1907 103.42ZM99.4494 102.317L94.4209 97.9105L99.4494 80.8138V102.317Z",
    stroke: "#F4F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8766 110.747H102.87L101.565 86.9684H97.1821L95.8766 110.747Z",
    fill: "#F4F3F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.39873,
    height: 12.5886,
    transform: "matrix(1 0 0 -1 98.7207 92.0038)",
    fill: "#F4F3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.87 52H95.8766L97.1821 75.7785H101.565L102.87 52Z",
    fill: "#F4F3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.39873,
    height: 12.5886,
    transform: "matrix(-1 0 0 1 100.073 70.1835)",
    fill: "#F4F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 84.8702V77.8766L93.7785 79.1821V83.5648L70 84.8702Z",
    fill: "#F4F3F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.743,
    y: 82.0261,
    width: 1.39873,
    height: 12.5886,
    transform: "rotate(-90 88.743 82.0261)",
    fill: "#F4F3F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.747 77.8766V84.8702L104.968 83.5648V79.1821L128.747 77.8766Z",
    fill: "#F4F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 110.563,
    y: 80.674,
    width: 1.39873,
    height: 12.5886,
    transform: "rotate(90 110.563 80.674)",
    fill: "#F4F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.063 99.0885L126.56 93.0318L105.314 82.2732L103.123 86.0687L123.063 99.0885Z",
    fill: "#F4F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.39873,
    height: 12.5886,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 108.253 87.2539)",
    fill: "#F4F3F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6837 63.6584L72.1868 69.7151L93.4324 80.4738L95.6237 76.6782L75.6837 63.6584Z",
    fill: "#F4F3F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.39873,
    height: 12.5886,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 90.0323 75.1729)",
    fill: "#F4F3F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6837 99.0885L72.1869 93.0318L93.4324 82.2732L95.6237 86.0687L75.6837 99.0885Z",
    fill: "#F4F3F3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4936,
    y: 87.2539,
    width: 1.39873,
    height: 12.5886,
    transform: "rotate(-120 90.4936 87.2539)",
    fill: "#F4F3F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.063 63.6584L126.56 69.7151L105.314 80.4738L103.123 76.6782L123.063 63.6584Z",
    fill: "#F4F3F3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108.714,
    y: 75.1729,
    width: 1.39873,
    height: 12.5886,
    transform: "rotate(60 108.714 75.1729)",
    fill: "#F4F3F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.032 108.56L117.088 105.063L104.069 85.1231L100.273 87.3145L111.032 108.56Z",
    fill: "#F4F3F3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.39873,
    height: 12.5886,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 104.123 90.906)",
    fill: "#F4F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7151 54.1869L81.6584 57.6837L94.6782 77.6237L98.4737 75.4324L87.7151 54.1869Z",
    fill: "#F4F3F3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.39873,
    height: 12.5886,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 94.3841 71.333)",
    fill: "#F4F3F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.715 108.56L81.6583 105.063L94.6782 85.1231L98.4737 87.3145L87.715 108.56Z",
    fill: "#F4F3F3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 94.6235,
    y: 90.906,
    width: 1.39873,
    height: 12.5886,
    transform: "rotate(-150 94.6235 90.906)",
    fill: "#F4F3F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.032 54.1869L117.088 57.6837L104.069 77.6237L100.273 75.4324L111.032 54.1869Z",
    fill: "#F4F3F3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 104.363,
    y: 71.333,
    width: 1.39873,
    height: 12.5886,
    transform: "rotate(30 104.363 71.333)",
    fill: "#F4F3F3"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7975,
    y: 80.7975,
    width: 41.4684,
    height: 1.1519,
    fill: "#F4F3F3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.962 75.038L161 72.7342L156.968 79.6456L161 87.1329L137.962 85.4051V75.038Z",
    fill: "#F4F3F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkLogo);
export default __webpack_public_path__ + "static/media/mark-logo.fe2cc0c2.svg";
export { ForwardRef as ReactComponent };